import { useLazyQuery } from '@apollo/client'
import { useEffect } from 'react'

import {
  PersistentAlertBannerQuery,
  PersistentAlertBannerQueryVariables,
} from './__generated__/query.graphql'
import { PERSISTENT_ALERT_BANNER_QUERY } from './query'

export const PersistentAlertBanner = () => {
  const [fetchQuery] = useLazyQuery<
    PersistentAlertBannerQuery,
    PersistentAlertBannerQueryVariables
  >(PERSISTENT_ALERT_BANNER_QUERY)

  useEffect(() => {
    fetchQuery()
  }, [fetchQuery])

  return <div id="persistent-alert-banner"></div>
}
